// Colors Theme Constant
export type THEME_LIST =
    | 'Clair'
    | 'Sombre'
    | 'Thème'
    | 'Bleu'
    | 'Vert'
    | 'Rouge'
    | 'Rose'
    | 'Noir'
    | 'Violet'
    | 'Indigo'
    | 'Orange'
    | 'Original';

export const LIGHT_THEME: THEME_LIST = 'Clair';
export const DARK_THEME: THEME_LIST = 'Sombre';
export const THEME_COLOR: THEME_LIST = 'Thème';
export const BLUE_THEME: THEME_LIST = 'Bleu';
export const GREEN_THEME: THEME_LIST = 'Vert';
export const RED_THEME: THEME_LIST = 'Rouge';
export const PINK_THEME: THEME_LIST = 'Rose';
export const BLACK_THEME: THEME_LIST = 'Noir';
export const PURPLE_THEME: THEME_LIST = 'Violet';
export const INDIGO_THEME: THEME_LIST = 'Indigo';
export const ORANGE_THEME: THEME_LIST = 'Orange';
export const L2D_THEME: THEME_LIST = 'Original';

export const ALL_THEMES: THEME_LIST[] = [
    LIGHT_THEME,
    DARK_THEME,
    THEME_COLOR,
    BLUE_THEME,
    GREEN_THEME,
    RED_THEME,
    PINK_THEME,
    BLACK_THEME,
    PURPLE_THEME,
    INDIGO_THEME,
    ORANGE_THEME,
    L2D_THEME,
];

// Config constants
export const SET_ID_SOCIETE = 'SET_ID_SOCIETE';
export const SET_ENV = 'SET_ENV';
export const SET_ENV_API = 'SET_ENV_API';
export const SET_ALL_ENVS = 'SET_ALL_ENVS';
export const SET_ID_PRESCRIPTEUR = 'SET_ID_PRESCRIPTEUR';
export const SET_PRESCRIPTEURS = 'SET_PRESCRIPTEURS';
export const IS_AUTO_MODE_ENABLED = 'IS_AUTO_MODE_ENABLED';

// export * from './selectors';
export * from './document';
export * from './slicename';
export * from './env';
export { default as APIENV } from './env';
